import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ProductGrid from "@/components/feature/ProductGrid";
import AvailabilityNotice from "@/components/feature/AvailabilityNotice";
import PartRequestNotice from "@/components/feature/PartRequestNotice";
import { useProducts } from "@/hooks/useProducts";

export default function BodyParts() {
  const { t } = useTranslation();
  const products = useProducts("Body Parts");

  return (
    <div className="min-h-screen bg-white font-body">
      <Navbar />
      <main>
        <ProductGrid
          title={t("nav.bodyParts")}
          subtitle={t("page.bodyPartsSubtitle")}
          parts={products}
          notice={<AvailabilityNotice category={t("nav.bodyParts")} />}
        />
        <PartRequestNotice />
      </main>
      <Footer />
    </div>
  );
}